import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { formatDate, formatAmount } from '../utils/helpers';

const PublicProfile = () => {
  const { username } = useParams();
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!username) {
      setError('Missing username');
      setLoading(false);
      return;
    }
    fetch(`/api/u/${encodeURIComponent(username)}`)
      .then(res => { if (!res.ok) throw new Error(res.status === 404 ? 'User not found' : 'Failed to fetch'); return res.json(); })
      .then(data => {
        // Server now returns { receipts, total, page, limit, total_pages }
        // for pagination. Older responses (raw array) are still accepted.
        const list = Array.isArray(data) ? data : (data.receipts || []);
        setReceipts(list);
        setLoading(false);
      })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [username]);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="public-profile">
      <div className="public-header">
        <h1>@{username}'s Receipts</h1>
        <p>Public verification page</p>
      </div>
      
      {receipts.length === 0 ? (
        <div className="no-receipts"><p>No public receipts</p></div>
      ) : (
        <div className="receipts-table-container">
          <table className="receipts-table">
            <thead><tr><th>ID</th><th>Amount</th><th>Recipient</th><th>Date</th><th>Hash</th></tr></thead>
            <tbody>
              {receipts.map(receipt => (
                <tr key={receipt.id}>
                  <td>#{receipt.id}</td>
                  <td className="amount">{formatAmount(receipt.amount, receipt.type)}</td>
                  <td>{receipt.recipient}</td>
                  <td>{formatDate(receipt.date)}</td>
                  <td><code className="hash-small" title={receipt.sha256_hash}>{receipt.sha256_hash.substring(0, 16)}...</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      
      <div className="public-footer">
        <p>Verify authenticity using SHA-256 hash</p>
        <Link to="/login" className="btn btn-primary">Login to Create</Link>
      </div>
    </div>
  );
};

export default PublicProfile;
